"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function LoginPage() {
  const router = useRouter();
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  async function handleLogin(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error ?? "Login failed"); return; }
      router.push("/");
      router.refresh();
    } catch {
      setError("Something went wrong");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: "100vh", background: "#07090F", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: "#0D111C", border: "1px solid #1C2540", borderRadius: 16, padding: 40, width: 400 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 32 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg, #3B82F6 0%, #9B59D0 100%)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>⚡</div>
          <span style={{ fontWeight: 800, fontSize: 20, color: "#EEF2FF", letterSpacing: "-0.04em" }}>Meridian</span>
        </div>

        <h1 style={{ color: "#EEF2FF", fontSize: 22, fontWeight: 700, marginBottom: 6 }}>Welcome back</h1>
        <p style={{ color: "#8898BB", fontSize: 14, marginBottom: 28 }}>Sign in to your account</p>

        <form onSubmit={handleLogin}>
          <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#8898BB", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.08em" }}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
            style={{ width: "100%", background: "#131929", border: "1px solid #1C2540", borderRadius: 8, color: "#EEF2FF", padding: "10px 14px", fontSize: 14, marginBottom: 16, outline: "none", boxSizing: "border-box" }} />

          <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#8898BB", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.08em" }}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
            style={{ width: "100%", background: "#131929", border: "1px solid #1C2540", borderRadius: 8, color: "#EEF2FF", padding: "10px 14px", fontSize: 14, marginBottom: 8, outline: "none", boxSizing: "border-box" }} />

          {error && <p style={{ color: "#F43F5E", fontSize: 12, marginBottom: 12 }}>{error}</p>}

          <button type="submit" disabled={loading}
            style={{ width: "100%", background: loading ? "#1C2540" : "#3B82F6", border: "none", borderRadius: 8, color: "#fff", padding: "11px 0", fontSize: 14, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", marginTop: 8 }}>
            {loading ? "Signing in..." : "Sign in →"}
          </button>
        </form>
      </div>
    </div>
  );
}
